module.exports = __webpack_public_path__ + "static/img/img-07.84effb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-07.jpg
// module id = 90
// module chunks = 0